<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mt-2 mb-3 flex">
          <li>
            <div class="cursor-pointer" @click="goBack">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </div>
          </li>
          <li>
            <h3>{{ $t("setup.label.view_group_ticket") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      v-if="
                        groupTicketById && groupTicketById.status !== 'CLOSED'
                      "
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="goToEdit()"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <!-- <pre>{{ ticket }}</pre> -->
              <tr>
                <td>
                  <b>{{ $t("customers.label.title") }}</b>
                </td>
                <td>{{ ticket.title }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.groupName") }}</b>
                </td>
                <td>{{ ticket.groupName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.category") }}</b>
                </td>
                <td>{{ this.categoryText }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.sub_category") }}</b>
                </td>
                <td>{{ this.subCategoryText }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.created_date") }}</b>
                </td>
                <td v-if="ticket.ticketDate">
                  {{ getDate(ticket.ticketDate) }}
                </td>
                <td v-else>-</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.created_time") }}</b>
                </td>
                <td v-if="ticket.ticketDate">
                  {{ getTime(ticket.ticketDate) }}
                </td>
                <td v-else>-</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.priority") }}</b>
                </td>
                <td>{{ ticket.severity }}</td>
              </tr>
              <!-- <tr>
                <td>
                  <b>{{ $t("customers.label.source") }}</b>
                </td>
                <td>{{ ticket.sourceOfTicket }}</td>
              </tr> -->
              <tr></tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.due_time") }}</b>
                </td>
                <td>
                  {{ getDate2(ticket.dueTime) }} {{ getTime(ticket.dueTime) }}
                </td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.description") }}</b>
                </td>
                <td>{{ ticket.description }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.groupDescription") }}</b>
                </td>
                <td>{{ ticket.groupDescription }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.city") }}</b>
                </td>
                <td>{{ cityName }}</td>
              </tr>
            </table>
            <div v-if="ticket.linkedTickets && ticket.linkedTickets.length">
              <vs-table max-items="5" pagination :data="ticket.linkedTickets">
                <template slot="header">
                  <div class="mr-2 mb-1 order-1"></div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.TicketId") }}</vs-th>
                  <vs-th>{{ $t("setup.label.LinkedAt") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Remarks") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr :key="index" :data="ticket" v-for="(e, index) in data">
                    <vs-td :data="e.ticketId">{{ e.ticketId }}</vs-td>
                    <vs-td :data="e.linkedAt"
                      >{{ getDate(e.linkedAt) }}
                      {{ getTime(e.linkedAt) }}</vs-td
                    >
                    <vs-td :data="e.remarks">{{ e.remarks }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      :title="$t('setup.label.group_ticketing')"
      @deletePressed="confirmDelete()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ViewGroupingTicket",
  data() {
    return {
      ticket: {},
      selectedTickets: [],
      deleteUserDataPopup: false,
      affectedRegions: null,
    };
  },
  computed: {
    ...mapState({
      ticketTemplates: (s) => s.entity.ticketTemplate,
      subCategoryItem: (s) => s.entity.ticketSubcategory,
      groupTickets: (s) => s.groupTicketing.groupTickets,
      groupTicketById: (s) => s.groupTicketing.groupTicketById,
      cityTemplate: (s) => s.entity.template,
      formattedDate: (s) => s.settings.selectedDateFormat,
    }),
    categoryText() {
      const cat = (this.ticketTemplates.problemsDatas || []).find(
        (c) => c.id === this.ticket.categoryId
      );
      return cat ? cat.mCodeValue : "";
    },
    subCategoryText() {
      const sub = (this.subCategoryItem || []).find(
        (s) => s.id === this.ticket.subcategoryId
      );
      return sub ? sub.subCategory : "";
    },
    cityName() {
      const affectedRegions = this.ticket.affectedRegions || [];
      const cityDatas = this.cityTemplate.addressData.cityDatas || [];
      if (!Array.isArray(affectedRegions) || !affectedRegions.length) return "";

      const names = affectedRegions
        .map((id) => {
          const city = cityDatas.find((c) => c.id === id);
          return city ? city.cityName : null;
        })
        .filter(Boolean);

      return names.join(", ");
    },
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getDate2(date) {
      const d = moment(date, "DD MM YYYY HH:mm:ss");
      return d.format(this.formattedDate);
    },
    getTime(time) {
      return moment(time).format("HH:mm:ss");
    },
    async fetchGroup() {
      const { id } = this.$route.params;
      const resp = await this.$store.dispatch(
        "groupTicketing/getGroupTicketById",
        id
      );
      await this.$store.dispatch("entity/setTicketTemplate");
      this.ticket = {
        id: resp.id,
        title: resp.title,
        description: resp.description,
        categoryId: resp.categoryId,
        subcategoryId: resp.subcategoryId,
        severity: resp.severity,
        ticketDate: resp.createdDate,
        dueTime: resp.dueTime,
        sourceOfTicket: resp.sourceOfTicket,
        groupName: resp.groupName,
        groupDescription: resp.groupDescription,
        affectedRegions: resp.affectedRegions,
        linkedTickets: resp.linkedTickets,
      };

      await this.$store.dispatch("groupTicketing/getGroupTickets", {
        region: this.ticket.affectedRegions,
        categoryId: resp.categoryId,
        subCategoryId: resp.subcategoryId,
      });

      this.selectedTickets = this.groupTickets.filter((t) =>
        resp.ticketIds.includes(t.id)
      );
    },
    goToEdit() {
      this.$router.push({
        name: "Edit Group Ticketing",
        params: { id: this.$route.params.id },
      });
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("entity/setTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async confirmDelete() {
      this.deleteUserDataPopup = false;
      const id = this.$route.params.id;
      try {
        const data = {
          id: id,
          forceDelete: false,
        };
        await this.$store.dispatch("groupTicketing/deleteGroupTicket", data);
        this.$swal({
          title: "Success",
          text: "Group Ticketing Deleted Successfully",
          icon: "success",
        });
        this.goBack();
      } catch (error) {
        let errorMsg = error && error.toString();
        let e = errorMsg.replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          html: `<h5 style='display: block; text-align: center;'>${e}</h5>`,
          icon: "error",
          showCancelButton: true,
          confirmButtonText: "Force Delete",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#FF0000",
          customClass: {
            confirmButton: "no-outline-btn",
            cancelButton: "no-outline-btn",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            this.forceDelete(id);
          }
        });
      }
    },
    async forceDelete(id) {
      try {
        const data = {
          id: id,
          forceDelete: true,
        };
        await this.$store.dispatch("groupTicketing/deleteGroupTicket", data);
        this.$swal({
          title: "Success",
          text: "Group Ticketing Force Deleted Successfully",
          icon: "success",
        });
        this.goBack();
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error,
          icon: "error",
        });
      }
    },
    async getSubCategory() {
      this.$store.dispatch(
        "entity/setTicketSubcategory",
        this.$route.params.categoryId
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  async mounted() {
    await this.fetchGroup();
    await this.getTemplate();
    await this.getSubCategory();
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
